import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ActivityLog from './components/ActivityLog.vue';
import ActivityAttendance from './components/ActivityAttendance.vue';
import { PERMISSIONS } from '@/enum';
import { can } from '@/composables';

export default /*@__PURE__*/_defineComponent({
  __name: 'Activity',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(can)([_unref(PERMISSIONS).PERSON_LOGS_INDEX]))
      ? (_openBlock(), _createBlock(ActivityLog, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ActivityAttendance)
  ], 64))
}
}

})